import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import {TimelineLite, Power1}from 'gsap';
import Display from '../parts/display';

import { Link } from 'react-router';


class Landing extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false
		};
		this.tl = new TimelineLite();
		this.logo = new TimelineLite();
		this.skip = this.skip.bind(this);
		this.animatedOut = this.animatedOut.bind(this);
	}
	componentDidMount() {
		let _this = this;

		let rfs = this.refs;

		let [ind, forwardTH, nking, go, engag, insp, ring, convert, ng, lt, links, parah,] =
			[rfs.ind, rfs.forwardTh, rfs.nking, rfs.go, rfs.engag, rfs.insp, rfs.ring, rfs.convert, rfs.ng, rfs.landingText, rfs.links, rfs.parah];

		this.tl.to(lt, .6, {opacity: 1})
			.to(ind, .3, {x: '-122%', ease:Power1.easeOut})
			.to(go, .3, {x: '138%', ease:Power1.easeOut}, '-=.3')
			.to({}, 1, {})
			.to(ind, .2, {x: '0%', ease:Power1.easeOut})
			.to(go, .2, {x: '0%', ease:Power1.easeOut}, '-=.3')
			.to(forwardTH, .2, {x: '-109%', ease:Power1.easeOut})
			.to(nking, .2, {x: '118%', ease:Power1.easeOut}, '-=.3')
			.to({}, 1, {})
			.to(forwardTH, .2, {x: '0%', ease:Power1.easeOut})
			.to(nking, .2, {x: '0%', ease:Power1.easeOut}, '-=.3')
			.to(ng, .2, {x: '146%', ease:Power1.easeOut})
			.to(engag, .2, {x: '-117%', ease:Power1.easeOut}, '-=.3')
			.to({}, 1, {})
			.to(engag, .2, {x: '0%', ease:Power1.easeOut})
			.to(ng, .2, {x: '0%', ease:Power1.easeOut}, '-=.3')
			.to(insp, .2, {x: '-117%', ease:Power1.easeOut})
			.to(ring, .2, {x: '128%', ease:Power1.easeOut}, '-=.3')
			.to({}, 1, {})
			.to(insp, .2, {x: '0%', ease:Power1.easeOut})
			.to(ring, .2, {x: '0%', ease:Power1.easeOut}, '-=.3')
			.to(ng, .2, {x: '146%', ease:Power1.easeOut})
			.to(convert, .2, {x: '-109%', ease:Power1.easeOut}, '-=.3')
			.to({}, 1, {})
			.to(convert, .2, {x: '0%', ease:Power1.easeOut})
			.to(ng, .2, {x: '0%', ease:Power1.easeOut}, '-=.3')
			.to(ind, .2, {x: '-122%', ease:Power1.easeOut})
			.to(go, .2, {x: '138%', ease:Power1.easeOut}, '-=.3')
			.to(parah, 1, {opacity: 1}, "+=.3")
			.to(links, 1, {opacity: 1}, "-=.1")

			.call(function () {
				if (!_this.state.animated) {
					_this.setState({
						animated: true
					});
				}
				_this.props.actions.showMenu(true);
			});
		// this.tl.fromTo(rect, 1, {x: -500}, {x: 500});

		//actions.hideNavBar();

		if(localStorage.getItem('splash')){
			_this.props.actions.showMenu(true);
		}

		if (sessionStorage.getItem('splash') ||
			window.innerWidth < 676) {
			this.skip();
		} else {
			sessionStorage.setItem('splash', true);
			localStorage.setItem('splash', true);
		}



		//store.on('triggerOut', this.animatedOut)
	}
	componentWillReceiveProps(nextProps, next){
		if(nextProps.site.pageChange !== this.props.site.pageChange){
			if(nextProps.site.pageChange.next !== '/'){
				this.animatedOut(nextProps.site.pageChange.callback);
			}
		}
	}
	componentWillUnmount(){
		//store.removeListener('triggerOut', this.animatedOut);
	}
	skip(){
		this.tl.progress(1);
	}
	animatedOut(callback){
		let _this = this;
		this.logo.to(this.refs.logoAnim, .5, {opacity: 0})
			.to(this.refs.parah, .5, {opacity: 0}, "-=.5")
			.to(this.refs.links, .5, {opacity: 0}, '-=.5')
			.to(this.refs.landingPage, .5, {height: "65px"}).call(function(){
				callback();
		});
	}
	render() {
		return (
			<div>
				<div className="landing-page" ref="landingPage">
					<div className="landing-text animated fadeIn" ref="landingText">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 792.86 49.55" ref="logoAnim">
							<defs>
								<clipPath id="clip-path" transform="translate(0 2.86)">
									<polygon points="0 0 0 46.31 387.55 46.31 404.78 0 0 0" fill="none"/>
								</clipPath>
								<clipPath id="clip-path-2" transform="translate(0 2.86)">
									<polygon points="792.86 0 404.78 0 387.55 46.31 792.86 46.31 792.86 0" fill="none"/>
								</clipPath>
							</defs>
							{/*<mask  id="go">*/}
							<g clipPath="url(#clip-path)">
								<g ref="ind">
									<path d="M472.64,45.79h-6.09L444.88,11.41l-.19.06V45.79H438.6V.78h6.09l21.67,34.34.19-.06V.78h6.09Z" transform="translate(0 2.86)" fill="#fff"/>
									<path d="M485.58,45.79V.78h14.16q8.81,0,14.17,5.42t5.36,14v6.15q0,8.63-5.36,14t-14.17,5.4Zm6.09-40.22V41h8.07a12.42,12.42,0,0,0,9.85-4.11,15.42,15.42,0,0,0,3.6-10.54V20.16a15.33,15.33,0,0,0-3.6-10.48,12.41,12.41,0,0,0-9.85-4.11Z" transform="translate(0 2.86)" fill="#fff"/>
									<polygon points="411.36 48.65 427.68 3.64 421.28 3.64 404.96 48.65 411.36 48.65" fill="#fff"/>
								</g>
								<g ref="engag">
									<path d="M437.43,25.1h-19.1V40.72h22.19v4.75h-28V1.39h27.7V6.15H418.32v14.2h19.1Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M481.63,45.47h-5.84l-22.19-34v34h-5.84V1.39h5.84l22.25,34.12V1.39h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M524.49,39.69a13.42,13.42,0,0,1-6.25,4.8,25.23,25.23,0,0,1-9.34,1.59,18.12,18.12,0,0,1-9.57-2.53,16.85,16.85,0,0,1-6.46-7.19,24.83,24.83,0,0,1-2.35-10.81V21.71q0-10,4.65-15.44T508.24.79q6.9,0,11.11,3.53a15.37,15.37,0,0,1,5.15,10h-5.81Q517,5.54,508.27,5.54q-5.84,0-8.86,4.11t-3,11.89v3.61q0,7.42,3.39,11.8a11,11,0,0,0,9.17,4.38,20.26,20.26,0,0,0,5.72-.72,8.85,8.85,0,0,0,4.06-2.45V28.28h-10.2V23.52h16Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M558.52,33.94H540.05l-4.15,11.53h-6L546.74,1.39h5.09l16.86,44.08h-6Zm-16.71-4.75h15L549.29,8.57Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M606.84,39.69a13.42,13.42,0,0,1-6.25,4.8,25.23,25.23,0,0,1-9.34,1.59,18.12,18.12,0,0,1-9.57-2.53,16.85,16.85,0,0,1-6.46-7.19,24.83,24.83,0,0,1-2.35-10.81V21.71q0-10,4.65-15.44T590.58.79q6.9,0,11.11,3.53a15.37,15.37,0,0,1,5.15,10H601q-1.63-8.78-10.41-8.78-5.84,0-8.86,4.11t-3,11.89v3.61q0,7.42,3.39,11.8a11,11,0,0,0,9.17,4.38A20.26,20.26,0,0,0,597,40.6a8.85,8.85,0,0,0,4.06-2.45V28.28h-10.2V23.52h16Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
								<g ref="insp">
									<polygon points="411.19 48.55 427.51 3.54 421.11 3.54 404.78 48.55 411.19 48.55" fill="#fff"/>
									<path d="M470.15,45.19H464.3l-22.19-34v34h-5.84V1.12h5.84l22.25,34.12V1.12h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M493.46,25.55Q486,23.4,482.57,20.26a10.09,10.09,0,0,1-3.41-7.74,10.66,10.66,0,0,1,4.16-8.61Q487.49.51,494.15.51a18.07,18.07,0,0,1,8.1,1.76,13.33,13.33,0,0,1,5.51,4.84,12.39,12.39,0,0,1,2,6.75h-5.84a8.06,8.06,0,0,0-2.54-6.3q-2.54-2.29-7.17-2.29a10.59,10.59,0,0,0-6.71,1.9A6.33,6.33,0,0,0,485,12.42,5.69,5.69,0,0,0,487.33,17q2.29,1.87,7.78,3.41a36.17,36.17,0,0,1,8.6,3.41,13.07,13.07,0,0,1,4.6,4.34A11.1,11.1,0,0,1,509.8,34a10.3,10.3,0,0,1-4.18,8.58q-4.18,3.23-11.17,3.22A20.72,20.72,0,0,1,486,44.06a14.26,14.26,0,0,1-6.07-4.77,11.63,11.63,0,0,1-2.13-6.87h5.84a7.59,7.59,0,0,0,3,6.31A12.43,12.43,0,0,0,494.46,41q4.6,0,7.05-1.88A6.1,6.1,0,0,0,504,34.05a6,6,0,0,0-2.27-5Q499.42,27.27,493.46,25.55Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M523.06,27.94V45.19h-5.81V1.12h16.26q7.23,0,11.34,3.69a12.52,12.52,0,0,1,4.1,9.78q0,6.42-4,9.88t-11.49,3.47Zm0-4.75h10.44q4.66,0,7.14-2.2a8,8,0,0,0,2.48-6.35,8.31,8.31,0,0,0-2.48-6.31,9.79,9.79,0,0,0-6.81-2.46H523.06Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
								<g ref="convert">
									<path d="M438.82,31.21q-.82,7-5.16,10.79t-11.55,3.8a15.53,15.53,0,0,1-12.52-5.6q-4.71-5.6-4.71-15V21a25.12,25.12,0,0,1,2.19-10.81A16.39,16.39,0,0,1,413.3,3a17.31,17.31,0,0,1,9.32-2.5q7,0,11.26,3.92t4.93,10.85H433q-.76-5.28-3.28-7.65a9.94,9.94,0,0,0-7.07-2.37,10.4,10.4,0,0,0-8.73,4.12q-3.16,4.12-3.16,11.73v4.27q0,7.18,3,11.42A9.68,9.68,0,0,0,422.11,41q4.84,0,7.43-2.19T433,31.21Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M480.66,24.58a27.27,27.27,0,0,1-2.18,11.31,16.51,16.51,0,0,1-6.18,7.37,17,17,0,0,1-24.81-7.31,26.17,26.17,0,0,1-2.29-11V21.79a26.94,26.94,0,0,1,2.21-11.23A16.34,16.34,0,0,1,462.92.51a17.09,17.09,0,0,1,9.34,2.56,16.48,16.48,0,0,1,6.22,7.42,27.4,27.4,0,0,1,2.18,11.31Zm-5.78-2.85q0-7.84-3.15-12a10.39,10.39,0,0,0-8.81-4.19,10.27,10.27,0,0,0-8.67,4.19q-3.16,4.19-3.25,11.64v3.24q0,7.6,3.19,11.94a11.19,11.19,0,0,0,17.51.24q3.09-4.1,3.18-11.76Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M523.26,45.19h-5.84l-22.19-34v34h-5.84V1.12h5.84l22.25,34.12V1.12h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M548.17,37.47,560.77,1.12h6.36L550.78,45.19h-5.15L529.31,1.12h6.33Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M597.94,24.82h-19.1V40.44H601v4.75H573V1.12h27.7V5.87H578.84v14.2h19.1Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M624.43,27.36H614.08V45.19h-5.84V1.12h14.59q7.45,0,11.46,3.39t4,9.87a11.86,11.86,0,0,1-2.23,7.17,13.28,13.28,0,0,1-6.19,4.57l10.35,18.71v.36H634Zm-10.35-4.75H623a10.07,10.07,0,0,0,6.89-2.24,7.59,7.59,0,0,0,2.56-6A8,8,0,0,0,630,8.08q-2.44-2.18-7-2.21h-8.9Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M674.47,5.87H660.31V45.19h-5.78V5.87H640.39V1.12h34.09Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
								<g ref="forwardTh">
									<path d="M433.75,25.73h-18.5V45.19h-5.81V1.12h27.31V5.87H415.25V21h18.5Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M477.61,24.58a27.27,27.27,0,0,1-2.18,11.31,16.51,16.51,0,0,1-6.18,7.37,17,17,0,0,1-24.81-7.31,26.17,26.17,0,0,1-2.29-11V21.79a26.94,26.94,0,0,1,2.21-11.23A16.35,16.35,0,0,1,459.87.51a17.09,17.09,0,0,1,9.34,2.56,16.47,16.47,0,0,1,6.22,7.42,27.4,27.4,0,0,1,2.18,11.31Zm-5.78-2.85q0-7.84-3.15-12a10.39,10.39,0,0,0-8.81-4.19A10.27,10.27,0,0,0,451.2,9.7q-3.16,4.19-3.25,11.64v3.24q0,7.6,3.19,11.94a11.19,11.19,0,0,0,17.51.24q3.09-4.1,3.18-11.76Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M502.5,27.36H492.14V45.19H486.3V1.12h14.59q7.45,0,11.46,3.39t4,9.87a11.86,11.86,0,0,1-2.23,7.17,13.27,13.27,0,0,1-6.19,4.57L518.3,44.83v.36h-6.24Zm-10.35-4.75h8.93A10.07,10.07,0,0,0,508,20.37a7.59,7.59,0,0,0,2.56-6,8,8,0,0,0-2.44-6.28q-2.44-2.18-7-2.21h-8.9Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M534,31.3l.85,5.81,1.24-5.24,8.72-30.76h4.9l8.51,30.76,1.21,5.33.94-5.93,6.84-30.15h5.84L562.38,45.19h-5.3L548,13.07l-.7-3.36-.7,3.36-9.42,32.12h-5.3L521.24,1.12H527Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M602.55,33.66H584.08l-4.15,11.53h-6L590.77,1.12h5.09l16.86,44.08h-6Zm-16.71-4.75h15L593.32,8.29Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M634.82,27.36H624.47V45.19h-5.84V1.12h14.59q7.45,0,11.46,3.39t4,9.87a11.86,11.86,0,0,1-2.23,7.17,13.27,13.27,0,0,1-6.19,4.57l10.35,18.71v.36h-6.24Zm-10.35-4.75h8.93a10.07,10.07,0,0,0,6.89-2.24,7.59,7.59,0,0,0,2.56-6,8,8,0,0,0-2.44-6.28q-2.44-2.18-7-2.21h-8.9Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M656.83,45.19V1.12h12.44a20,20,0,0,1,10.17,2.54,17.2,17.2,0,0,1,6.83,7.24,23.54,23.54,0,0,1,2.44,10.78v2.82a23.64,23.64,0,0,1-2.41,10.93,16.93,16.93,0,0,1-6.87,7.21A21.29,21.29,0,0,1,669,45.19Zm5.81-39.33V40.44h6.12q6.72,0,10.46-4.18T683,24.35V21.78q0-7.51-3.53-11.68t-10-4.23Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M742.08,5.87H727.91V45.19h-5.78V5.87H708V1.12h34.09Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M782.5,45.19h-5.84V24.82H754.43V45.19h-5.81V1.12h5.81v19h22.22v-19h5.84Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
							</g>
							<polygon points="391.47 48.65 407.8 3.64 401.39 3.64 385.07 48.65 391.47 48.65" fill="#fff"/>
							<g clipPath="url(#clip-path-2)">

								<g ref="go">
									<path d="M335.73,39.6a14.49,14.49,0,0,1-5.58,4.61,22,22,0,0,1-10.31,2.1A17.36,17.36,0,0,1,307,41.15q-5.1-5.16-5.1-13.36V18.52q0-8.19,4.92-13.36A16.72,16.72,0,0,1,319.44,0Q327,0,331.31,4a12.85,12.85,0,0,1,4.24,10.19l-.06.19h-5.84A9.44,9.44,0,0,0,327,7.53q-2.66-2.74-7.54-2.73a10.21,10.21,0,0,0-8.32,3.86,15,15,0,0,0-3.15,9.8v9.33a14.6,14.6,0,0,0,3.34,9.88,10.76,10.76,0,0,0,8.53,3.88,15.86,15.86,0,0,0,6.32-1,9.13,9.13,0,0,0,3.48-2.46V27.91h-10.2V23.15h16.29Z" transform="translate(0 2.86)" fill="#fff"/>
									<path d="M382.79,27.17a19.21,19.21,0,0,1-5.12,13.7,17.4,17.4,0,0,1-13.28,5.44,16.49,16.49,0,0,1-12.81-5.44,19.62,19.62,0,0,1-4.93-13.7v-8a19.69,19.69,0,0,1,4.93-13.7A16.45,16.45,0,0,1,364.4,0a17.37,17.37,0,0,1,13.28,5.46,19.26,19.26,0,0,1,5.12,13.71ZM376.7,19.1A15.18,15.18,0,0,0,373.36,9a11.13,11.13,0,0,0-9-4,10.31,10.31,0,0,0-8.49,4,15.72,15.72,0,0,0-3.17,10.14v8.07a15.81,15.81,0,0,0,3.17,10.2,10.31,10.31,0,0,0,8.49,4,11.13,11.13,0,0,0,9-3.94,15.31,15.31,0,0,0,3.32-10.22Z" transform="translate(0 2.86)" fill="#fff"/>
								</g>

								<g ref="ng">
									<path d="M337.09,44.48h-5.84l-22.19-34v34h-5.84V.4h5.84l22.25,34.12V.4h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M380,38.7a13.42,13.42,0,0,1-6.25,4.8,25.23,25.23,0,0,1-9.34,1.59,18.12,18.12,0,0,1-9.57-2.53,16.85,16.85,0,0,1-6.46-7.19A24.83,24.83,0,0,1,346,24.56V20.72q0-10,4.65-15.44T363.7-.2q6.9,0,11.11,3.53a15.37,15.37,0,0,1,5.15,10h-5.81q-1.63-8.78-10.41-8.78-5.84,0-8.86,4.11t-3,11.89v3.61q0,7.42,3.39,11.8a11,11,0,0,0,9.17,4.38,20.26,20.26,0,0,0,5.72-.72,8.85,8.85,0,0,0,4.06-2.45V27.28H364V22.53h16Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
								<g ref="ring">
									<polygon points="280.37 48.55 296.7 3.54 290.29 3.54 273.97 48.55 280.37 48.55" fill="#fff"/>
									<path d="M251.92,27.36H241.57V45.19h-5.84V1.12h14.59q7.45,0,11.46,3.39t4,9.87a11.86,11.86,0,0,1-2.23,7.17,13.28,13.28,0,0,1-6.19,4.57l10.35,18.71v.36h-6.24Zm-10.35-4.75h8.93a10.07,10.07,0,0,0,6.89-2.24,7.59,7.59,0,0,0,2.56-6,8,8,0,0,0-2.44-6.28q-2.44-2.18-7-2.21h-8.9Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M335.35,45.19h-5.84l-22.19-34v34h-5.84V1.12h5.84l22.25,34.12V1.12h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M378.22,39.41a13.42,13.42,0,0,1-6.25,4.8,25.23,25.23,0,0,1-9.34,1.59,18.12,18.12,0,0,1-9.57-2.53,16.85,16.85,0,0,1-6.46-7.19,24.83,24.83,0,0,1-2.35-10.81V21.43q0-10,4.65-15.44T362,.51q6.9,0,11.11,3.53a15.37,15.37,0,0,1,5.15,10h-5.81Q370.77,5.26,362,5.26q-5.84,0-8.86,4.11t-3,11.89v3.61q0,7.42,3.39,11.8A11,11,0,0,0,362.66,41a20.26,20.26,0,0,0,5.72-.72,8.85,8.85,0,0,0,4.06-2.45V28h-10.2V23.25h16Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
								<g ref="nking">
									<polygon points="276.22 49.42 292.54 4.41 286.14 4.41 269.81 49.42 276.22 49.42" fill="#fff"/>
									<path d="M217.82,46.09H212l-22.19-34v34h-5.84V2h5.84L212,36.13V2h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M239.34,25.6,234,31.2V46.09h-5.81V2H234v21.8L253.54,2h7L243.22,21.48l18.71,24.61h-7Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M337.14,46.09h-5.84l-22.19-34v34h-5.84V2h5.84l22.25,34.12V2h5.78Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
									<path d="M380,40.31a13.42,13.42,0,0,1-6.25,4.8,25.23,25.23,0,0,1-9.34,1.59,18.12,18.12,0,0,1-9.57-2.53A16.85,16.85,0,0,1,348.38,37,24.83,24.83,0,0,1,346,26.17V22.33q0-10,4.65-15.44t13.06-5.48q6.9,0,11.11,3.53a15.37,15.37,0,0,1,5.15,10h-5.81q-1.63-8.78-10.41-8.78-5.84,0-8.86,4.11t-3,11.89v3.61q0,7.42,3.39,11.8a11,11,0,0,0,9.17,4.38,20.26,20.26,0,0,0,5.72-.72,8.85,8.85,0,0,0,4.06-2.45V28.9H364V24.14h16Z" transform="translate(0 2.86)" fill="rgba(255,255,255,0.6)"/>
								</g>
							</g>
							{/*</mask>*/}
							{/*<rect className="water-fill" ref="rect" mask="url(#go)" fill="#fff" x="0" y="0" width="100%" height="120"/>*/}
						</svg>
						<p ref="parah">award winning digital agency</p>
					</div>
					<div className="landing-links" ref="links">
						<ul>
							<li>
								<Link to='/services'>services</Link>
							</li>
							<li>
								<Link to='/portfolio'>portfolio</Link>
							</li>
							<Display if={!this.props.site.sentStartProject}>
								<li>

									<Link to={{
										pathname: '/start-project',
										state: { modal: true, returnTo: '/services'}
									}}>start your project</Link>
								</li>
							</Display>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);




/** WEBPACK FOOTER **
 ** ./src/js/components/home/landingPage.js
 **/